var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-384.000000, -199.000000)",
    stroke: "#0091da"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(385.000000, 198.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.500000, 6.500000) rotate(-270.000000) translate(-5.500000, -6.500000) "
  }, /*#__PURE__*/React.createElement("polyline", {
    transform: "translate(5.500000, 2.642857) rotate(-90.000000) translate(-5.500000, -2.642857) ",
    points: "3 -2 8 2.64285714 3 7.28571429"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: 0.5,
    x2: 5.5,
    y2: 12.5,
    strokeLinecap: "square"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowBlue);
export default __webpack_public_path__ + "static/media/icon-arrow-blue.d70e3f2ba5c5759c28d6f1e54433eff3.svg";
export { ForwardRef as ReactComponent };